import { motion } from 'framer-motion';

function About() {
  return (
    <motion.div
      className="about-div"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      <h2 className="about-h2">About Us:</h2>
      <p className="about-p">
        At Blina Construction, based in Calgary, Alberta, we believe that every
        home has a story to tell, and we're here to help you create the next
        chapter. Specializing in home renovations and restorations, we bring
        your vision to life with precision, passion, and a commitment to
        excellence.
      </p>
    </motion.div>
  );
}

export default About;
